export enum DownloadOption {
  CSV = "CSV",
  EXCEL = "EXCEL",
}
